import { createPortal } from 'react-dom';
import { RefreshCw } from 'lucide-react';
import { useAppUpdate } from '../hooks/useAppUpdate';
import { useT } from '../hooks/useT';

/** Meldt dat er een nieuwe versie klaarstaat en laadt die na een tik. */
export function UpdateToast() {
  const { t } = useT();
  const { updateAvailable, toastDismissed, dismissToast, update } = useAppUpdate();

  if (!updateAvailable || toastDismissed) return null;

  return createPortal(
    <div
      role="status"
      className="fixed bottom-6 left-1/2 z-[150] flex -translate-x-1/2 items-center gap-3 rounded-2xl bg-slate-900 py-2 pl-4 pr-2 text-sm font-semibold text-white shadow-2xl dark:bg-slate-100 dark:text-slate-900"
    >
      <RefreshCw className="h-4 w-4 shrink-0" aria-hidden />
      <span className="whitespace-nowrap">{t('updateAvailable')}</span>
      <button
        onClick={update}
        className="min-h-11 whitespace-nowrap rounded-xl bg-indigo-700 px-4 text-white transition-all duration-150 active:scale-95"
      >
        {t('updateNow')}
      </button>
      <button
        onClick={dismissToast}
        className="min-h-11 whitespace-nowrap rounded-xl px-3 text-white/70 dark:text-slate-600"
      >
        {t('updateLater')}
      </button>
    </div>,
    document.body,
  );
}
